import { render, staticRenderFns } from "./NoteHead.vue?vue&type=template&id=8412da40&scoped=true&"
import script from "./NoteHead.vue?vue&type=script&lang=js&"
export * from "./NoteHead.vue?vue&type=script&lang=js&"
import style0 from "./NoteHead.vue?vue&type=style&index=0&id=8412da40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8412da40",
  null
  
)

export default component.exports